import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '../../../../../common/uploadPhotoForm/avatar';
import BasicInfo from '../../../../../common/basicInfoForm/basicInfo';
import { USER_TYPES } from '../../../../../auth/constants';
import { canUserModifyBarbers, canUserModifyProfile, canUserViewProfile } from '../../../../../common/helpers/users';
import UploadPhoto from '../../../../../common/uploadPhotoForm/uploadPhoto';
import Tooltip from '../../../../../common/tooltip';
import SimpleCheckbox from '../../../../../common/simpleCheckbox';

const Profile = (props) => {
  const {
    disableUsername,
    onPopulateUsernameChange,
    showUsername,
    isUserEnabled,
    permissions,
    user,
    barberId,
    instagramUserId,
    instagram,
    avatar,
    isBrandViewActive,
    canEditBarberName,
    canEditBarberPersonnelId,
    onEmailChange,
  } = props;
  const disabled = !canUserModifyBarbers(permissions) || !canUserModifyProfile(permissions);
  const isBarberUser = user.kind === USER_TYPES.barber;

  return (
    <div className="u-mv" display-if={canUserViewProfile(permissions)}>
      <div className="u-pb">
        <div className="c-wrapper-horizontal u-pb">
          <div className="c-heading c-heading--dark large-and-up-mv c-heading--main-header">
            Add personal identification information
          </div>
          <div className="avatar-enabled-row">
            {!disabled && (
              <UploadPhoto name="avatar" className="c-avatar-upload" display-if={!disabled} checkInitialValue>
                {(imageUrl) => (
                  <Avatar size="small" iconClassName="o-icon--small" who="barber's" imageUrl={imageUrl} alt="" />
                )}
              </UploadPhoto>
            )}
            {disabled && (
              <Avatar size="small" iconClassName="o-icon--small" editable={false} who="barber's" imageUrl={avatar} />
            )}
            <div
              className="u-flex u-align-items-center"
              display-if={
                user.kind === USER_TYPES.admin ||
                user.kind === USER_TYPES.regularAdmin ||
                user.kind === USER_TYPES.agent ||
                user.kind === USER_TYPES.shop
              }
            >
              <SimpleCheckbox
                name="enabled"
                id="enabled"
                label={
                  <>
                    Visible online
                    <Tooltip className="u-type--no-transform c-info-tooltip-new--form">
                      <div className="u-m--">
                        Enabling this makes this staff member visible to your clients in online booking apps.
                        <br />
                        Disabling this still allows appointments to be added internally in your Appointments screen.
                      </div>
                    </Tooltip>
                  </>
                }
                disabled={disabled}
              />
            </div>
          </div>
        </div>
        <BasicInfo
          barber
          barberId={barberId}
          instagramUserId={instagramUserId}
          instagram={instagram}
          disableUsername={disableUsername}
          showUsername={showUsername}
          userEnabled={isUserEnabled}
          onPopulateUsernameChange={onPopulateUsernameChange}
          disabled={disabled}
          isBarberUser={isBarberUser}
          isBrandViewActive={isBrandViewActive}
          canEditBarberName={canEditBarberName}
          canEditBarberPersonnelId={canEditBarberPersonnelId}
          onEmailChange={onEmailChange}
        />
      </div>
    </div>
  );
};

Profile.propTypes = {
  disableUsername: PropTypes.bool,
  showUsername: PropTypes.bool,
  isUserEnabled: PropTypes.bool,
  onPopulateUsernameChange: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired,
  barberId: PropTypes.string,
  instagramUserId: PropTypes.string,
  instagram: PropTypes.string,
  user: PropTypes.object.isRequired,
  change: PropTypes.func.isRequired,
  currentEmailValue: PropTypes.string.isRequired,
  currentUsernameValue: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
  isBrandViewActive: PropTypes.bool,
  canEditBarberName: PropTypes.bool.isRequired,
  canEditBarberPersonnelId: PropTypes.bool.isRequired,
  onEmailChange: PropTypes.func.isRequired,
};

Profile.defaultProps = {
  disableUsername: false,
  showUsername: false,
  isUserEnabled: false,
  barberId: null,
  instagramUserId: null,
  instagram: '',
  isBrandViewActive: false,
};

export default Profile;
